import { render } from "./GenderDistributionByCampusChart.vue?vue&type=template&id=3096add6&scoped=true"
import script from "./GenderDistributionByCampusChart.vue?vue&type=script&lang=js"
export * from "./GenderDistributionByCampusChart.vue?vue&type=script&lang=js"

import "./GenderDistributionByCampusChart.vue?vue&type=style&index=0&id=3096add6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3096add6"

export default script